import { IsNumber, IsOptional, IsPositive, IsString } from "class-validator";

// -------------------
export class UpdateWeightPullWeighInDto {
  @IsNumber()
  @IsPositive()
  dog_weight!: number; // lbs

  @IsOptional()
  @IsString()
  weighed_by?: string; // initials of person who weighed the dog
}
